{
  "import_layer": {
    "title": "Import a layer",
    "confirm": "Import layers"
  },
  "data_fields": {
    "title": "Attributes",
    "add": "Add attribute",
    "project_data_fields": "Predefined attribute",
    "custom_data_field": "Custom attribute",
    "type": "Type",
    "name": "Attribute name",
    "list_name": "List Name",
    "list_items": "List items",
    "list_item": "List item",
    "types": {
      "Text": "Text",
      "List": "List",
      "Number": "Number",
      "Date": "Date",
      "Tickbox": "Tick box",
      "Time": "Time",
      "TimeRange": "Time range",
      "Image": "Image",
      "Hyperlink": "Hyperlink",
      "RepeatedTimeRanges": "Date & time ranges"
    },
    "data_driven_formula": {
      "title": "Create new formula",
      "label": "Determine {{ styleProperty }} by",
      "addListItem": "Add list item",
      "searchListItem": "Search for a list item"
    }
  },
  "saved_map_view": {
    "default_label": "Make this the plan's default view.",
    "default_description": "This defines the thumbnail image of the plan and loads this view for all users when they open the plan.",
    "form_header": "Name this saved view",
    "name_label": "Saved view name",
    "create_saved_view": "Create a saved view",
    "create_new_saved_view": "Create a new saved view",
    "edit_saved_view": "Edit the saved view",
    "move_map_around": "Move the plan around until you're happy with the new view.",
    "save_view_when_ready": "When you're ready, tap on 'Save Changes' to save the view.",
    "map_default": "plan default"
  },
  "create_map": {
    "create_map": "Create plan",
    "create_a_map": "Create a plan",
    "modal_label": "Plan name",
    "create_a_new_map": "Create a new plan"
  },
  "buttons": {
    "new_layer": "New layer",
    "import_layer": "Import layer",
    "site_map": "Sitemap",
    "background": "Background",
    "create_layer": "Create layer",
    "cancel": "Cancel",
    "share_table": "Share table",
    "download_table": "Download table",
    "toggle_sidebar": "Toggle sidebar",
    "columns_displayed": "Columns displayed",
    "closePopup": "Close popup",
    "openBasemapSelector": "Open basemap selector",
    "removeSiteMap": "Remove sitemap from view"
  },
  "labels": {
    "object": "Object",
    "object_id": "Object ID",
    "object_name": "Object name",
    "layer": "Layer",
    "zone": "Zone",
    "zones": "Zones",
    "client_group": "Client group"
  },
  "nav": {
    "layers": "layers",
    "data_table": "Data table",
    "sitemap": "Sitemap",
    "background": "Background",
    "basemap": "Basemap",
    "background_maps": "Background maps",
    "selectSitemap": "Select sitemap",
    "selectLevel": "Select level",
    "search": "Search"
  },
  "popup": {
    "view_by_layer": "View by layer",
    "view_by_data_field": "View by data field",
    "view_by_object": "View by object",
    "sitemapsAvailableAtThisLocation": "Sitemaps available at this location",
    "closeSitemapSelector": "Close sitemap selector",
    "sitemapLevels": "Sitemap levels",
    "closeLevelSelector": "Close level selector",
    "saved_map_views": "Saved views"
  },
  "add_layer": {
    "create_a_new_layer": "Create a new layer",
    "new_layer": "New Layer",
    "name_of_layer": "Name of layer",
    "layer_style": "Layer style",
    "layer_style_desc": "Choose a drawing type or select a style template",
    "drawing_type": "Drawing type",
    "area": "Area",
    "lines": "Lines",
    "points": "Points",
    "text_labels": "Text labels",
    "templates": "Templates",
    "shape_and_colour": "Shape and colour",
    "line_colour": "Line colour",
    "fill_opacity": "Fill opacity",
    "preview": "Preview",
    "width": "Width",
    "offset": "Offset",
    "zones": "Zones",
    "list_of_options": "List of options",
    "layer_design": "Layer Design",
    "layer_templates": "Layer Templates",
    "view_all_templates": "View All Layer Templates",
    "scratch": "Start a layer from scratch",
    "save_layer": "Save Layer",
    "type_of_layer": "Type of Layer",
    "styles": "Styles",
    "save_style": "Save Style",
    "more": "More",
    "Line": "Line",
    "Icon": "Icon",
    "Point": "Point",
    "Area": "Area",
    "layer_being_created": "Layer is being created..."
  },
  "measurements": {
    "unit_of_measurement": "Unit of measurement",
    "imperial": "Imperial",
    "metric": "Metric"
  },
  "sidebar": {
    "node_name": "Name needs to be at least 2 characters long"
  },
  "import_layers_tooltip": {
    "Layer": "Layer already exists in this plan"
  },
  "search": {
    "search_map": "Search",
    "locations": "Locations",
    "objects": "Objects",
    "search_description": "Search for location, saved view, object",
    "saved_map_view": "Saved views",
    "no_results": "No results matched your query",
    "sitemaps": "Sitemaps"
  }
}